// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33bQF","delete":"styles_delete__mELhZ","update":"styles_update__1ZoC4","add":"styles_add__1wTMB"};